import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

// -- entities
import ProductCategory from 'PMT/entities/menu/ProductCategory';

export default class CategoryRow extends Component {

  static propTypes = {
    category: PropTypes.instanceOf(ProductCategory).isRequired,

    onDelete: PropTypes.func.isRequired
  };


  shouldComponentUpdate(nextProps) {
    return !nextProps.category.equals(this.props.category);
  }

  onDisplayDetailClick = () => {
    RouteAction.presentCategoryDetail(this.category);
  };

  get category() {
    return this.props.category;
  }

  // -- renderers

  render() {
    return (
      <li>
        <h4 className="link-hover"
          onClick={this.onDisplayDetailClick}
        >
          {this.category.name}
        </h4>
        <i
          onClick={() => { this.props.onDelete(this.props.category); }}
          className="fa fa-trash pointer"
        />
      </li>
    );
  }

}
